import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid/ag-grid.service';
import { ImportDocumentsService } from 'src/app/components/import-documents/import-documents.service';
import { CurrentTab, FieldTypeAndPlaceHolder, RoutePath } from '../../model/enum';
import { TabsService } from '../tabs/tabs.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GridName } from '../../model/ag-grid-common-constant';

@Component({
  selector: 'app-ag-dropdown-correct-field',
  templateUrl: './ag-dropdown-correct-field.component.html',
  styleUrls: ['./ag-dropdown-correct-field.component.scss']
})
export class AgDropdownCorrectFieldComponent implements OnInit,ICellRendererAngularComp {
  active: boolean;
  @ViewChild("mySelect", { static: true }) mySelect: ElementRef;
  @Input() selectlist: any[] = [];
  params: any;
  placevalue:string;
  submit:boolean = true;
  submitted:boolean = true;
  errorselectlist;
  currentTab:string;
  tabName = CurrentTab;
  isSicCode: boolean = false;
  routePath = RoutePath;


  enumFieldTypeAndPlaceHolder = FieldTypeAndPlaceHolder;
  inputArray = [
    "Company", "Phone", "Email", "Company Email", "Accounting Contact", "Revenue", "Account Number", "Recent Notes", "D&B Number", "Fax", "NAICS", "Employees", "Sourcing Email", "Website", "SIC Description", "NAICS Code", "NAICS Year", "NAICS Description", "Industry", "Date Contacted", "Qty",
    "Company Name", "Company Phone", "Company Phone Number", "Company Email Address", "Company Fax Number", "Address Phone Number", "Main Office Number", "Main Office Number + Extension", "Contact Direct Number", "Contact Mobile Number", "Direct Number", "Contact Email", "Address Line 1", "Address Line 2", "Address VAT/RFC/CNPJ", "Details VAT/RFC/CNPJ", "Reseller ID", "Reseller ID Expiration Date", "Details Notes", "Contact Notes", "Tax ID", "Contact First Name", "Contact Last Name", "Title", "Department", "Location", "Skype", "Xing", "LinkedIn", "LinkdIn", "Address Name", "City", "Postal Code"
  ];
  inputVendorArray = [
    'Vendor Name', 'Email Address', 'Phone Number', 'Fax Number', 'Address 1', 'Address 2',
    'Address Name', 'Address Line 1', 'Address Line 2', 'Employees', 'Parent Company', 'Tax ID', 'Reseller ID', 'Reseller ID Expiration Date', 'Notes', 'Contact First Name', 'Contact Last Name', 'Title', 'Department', 'Location', 'Contact Email', 'Main Office Number', 'Direct Number', 'Contact Mobile Number', 'Contact Fax Number', 'Skype', 'Xing', 'LinkedIn'
  ];
  inputBOMArray = [
    'Customer Notes', 'Customer RFQ', 'Customer RFQ No.', 'Customer RFQ No', 'Qty', 'Customer PN', 'NSN', 'Description', 'Revision', 'Customer Target', 'Exchange Rate', 'Converted Target', 'Target Buy Price', 'End Customer', 'Project Name', 'Close Probability', 'Application', 'Opportunity Notes', 'SPQ', 'MOQ', 'HTS', 'Schedule B', 'ECCN', 'Temp Range', 'Additional Quantity'
  ];
  inputArrayCodeCrosswalk = [ ]
  value: any = '';
  ratingStarList =[
    {id:'star5', value:'5' , },
    {id:'star4.5', value:'4.5' , className:'halff'},
    {id:'star4', value:'4' , },
    {id:'star3.5', value:'3.5', className:'halff'},
    {id:'star3', value:'3' , },
    {id:'star2.5', value:'2.5', className:'halff'},
    {id:'star2', value:'2' , },
    {id:'star1.5', value:'1.5' , className:'halff'},
    {id:'star1', value:'1' , },
    {id:'star0.5', value:'0.5' , className:'halff'},
  ];
  routeUrl:string;
  shouldApplyOnlyNumbers: boolean = false; 
  
  constructor(public agGridService:AgGridService ,    
      public importDocumentsService:ImportDocumentsService,
      public tabsService: TabsService,
      private router: Router,
      public toaster: ToastrService,

    ) { }
  refresh(params: ICellRendererParams<any, any>): boolean {
    // throw new Error('Method not implemented.');
    return
  }
  ngOnInit(): void {
    this.routeUrl = this.router.url;

    this.importDocumentsService.mapValidation.subscribe((res)=>{
      if(res!==undefined){
        
        this.submit = res;
      }
    });
    this.importDocumentsService.errorValidation.subscribe((res)=>{
      if(res!==undefined){
        this.submitted = res;
      }
    });
    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
        this.importDocumentsService.count = 0;
        this.getCount();
      }
    })
  }
  agInit(params: ICellRendererParams) {
    this.shouldApplyOnlyNumbers = ['NAICS Code', 'SIC Code', 'NAICS Year', 'Phone', 'Phone Number'].includes(params.data.errorField);
    this.errorselectlist=params?.data?.companyName;
    this.selectlist=params.data.map;
    if(params.data.errorField){
      this.value=params?.data?.correctField;
      this.placevalue= this.showPlaceHolder(params.data.errorField)
    }else{
      this.value=params?.data?.mappedColumn;
      this.placevalue= ' Field-'
    }
    this.params = params;
    this.getCount()
  }

showPlaceHolder(name):string{
  if(name =="Phone"){
  return  name+' Number';
  }else if(name =="Company"){
    return name+' Name';
  }else{
    return name;
  }
}

  getCount(){
if(!this.params?.colDef?.cellRendererParams?.count)return
    this.importDocumentsService.count=0
    this.params.api.forEachNode((a)=>{
      if(!a.data.status){
        this.importDocumentsService.count++
      }
    })
  }

  checkFields(){
    const list=[];
    this.params.api.forEachNode((a)=>{
      list.push(a.data)
    })
    if(list.length==6){
      this.importDocumentsService.submit= this.importDocumentsService.checkRequiredValueCodecrosswalk(list);
    }else if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
      this.importDocumentsService.submit= this.importDocumentsService.checkVendorRequiredValue(list);
    }else if(this.routeUrl ==  this.routePath.IMPORTBOM_ROUTEPATH){
      this.importDocumentsService.submit = this.importDocumentsService.checkBOMRequiredValue(list);
    }else{
      this.importDocumentsService.submit=  this.importDocumentsService.checkRequiredValue(list);
    }
    this.importDocumentsService.submitted = this.importDocumentsService.checkRequiredValueError(list);
  }

  getType(): string {
    if (this.routeUrl == this.routePath.CODECROSSWALK_ROUTEPATH && this.params?.isErrorTab) {
      if (['SIC Code', 'NAICS Code', 'NAICS Year'].includes(this.params.data.errorField)) {
        return this.enumFieldTypeAndPlaceHolder.INPUT;
      } else {
        return this.enumFieldTypeAndPlaceHolder.DROPDOWN;
      }
    }
    
    if (this.routeUrl.includes(RoutePath.PARTLIST_IMPORT_ROUTEPATH) && this.params?.data?.errorField) {
      this.shouldApplyOnlyNumbers = ['Consigned Qty', 'Qty'].includes(this.params?.data?.errorField);
      let titles = ['Inventory','Part','OEMExcess','VendorParts','Consignment',];
      const dropdownFields = [ 'MFR','Part Status','Standard Packaging','Device Packaging','Temp Grade','Mount Type'];
      const dropdownInventoryFields = [ 'MPN','MFR','Standard Packaging','Received Packaging','UOM','Received In','Warehouse','RoHS','Condition','COO'];
      const urlSegment:any = this.router?.url?.split('/').pop();
      let fieldMapping:any
      switch(urlSegment){
        case titles[0]:
        case titles[2]:
        case titles[3]:
        case titles[4]:
          fieldMapping = dropdownInventoryFields
        break;
        case titles[1]:
          fieldMapping = dropdownFields
        break
      }
      return fieldMapping.includes(this.params.data.errorField)
        ? this.enumFieldTypeAndPlaceHolder.DROPDOWN
        : this.enumFieldTypeAndPlaceHolder.INPUT;
    }

    const field = this.params?.data?.errorField?.toLowerCase();
    const isInput = this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH
      ? this.inputVendorArray?.map(f => f.toLowerCase()).includes(field)
      : this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH
        ? this.inputBOMArray?.map(f => f.toLowerCase()).includes(field)
        : this.inputArray?.map(f => f.toLowerCase()).includes(field);

    if (isInput) {
      return this.enumFieldTypeAndPlaceHolder.INPUT;
    }

    return this.enumFieldTypeAndPlaceHolder.DROPDOWN;
  }


  valueChange(event) {
    this.value = event;
    const field = this.params?.data?.errorField;
    if (['Email', 'Company Email', 'Email Address'].includes(field)) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.value && !emailPattern.test(this.value)) {
        this.params.data.invalidEmail = true;
      }else {
        this.params.data.invalidEmail = false;
      }
    }
    this.params.setValue(this.value);
    if (this.params?.data?.errorField) {
      this.params.data.status = true;
    } else {
      this.params.data.status = !!this.value;
      this.importDocumentsService.isMappingChanged.next(true);
    }
    this.params.api.refreshCells({ columns: ["status"] });

    let length= this.params?.data?.map?.length??0;
    if (length > 0) {

      this.getCount();
      this.checkFields();
      this.params.setValue(event);
    }
  }

  //#endregion reduced code
  checkIfSicCode() {
    if(this.params.data.companyName == 'SIC Code'){
      if(this.params.data.correctField.length == 8){
        this.isSicCode = true; 
      }
    }
    else{
        this.isSicCode = false; 
      }
  }

  getMaxLength(): number {
   const field = this.params?.data?.errorField || '';
    if (field === 'Phone' || field === 'Phone Number') {
     return 15;
    }
    if (this.isSicCode) {
     return 8;
    }
    return 4;
  }

}



